module.exports = __webpack_public_path__ + "static/media/sachin.5943d5ac.jpeg";